<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="dialogRef.close()"
  >
    {{ 'am.dialog.explainAccess.closeBtn' | translate }}
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>
  <h3 class="cg-dialog__header">
    {{ 'am.dialog.explainAccess.header' | translate }}
  </h3>
  <mat-dialog-content>
    <p [innerHTML]="'am.dialog.explainAccess.delegate' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.patientsearch' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.claimsearch' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.reconsideration' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.remittance' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.directory' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.eft' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.precert' | translate"></p>
    <p [innerHTML]="'am.dialog.explainAccess.clinical' | translate"></p>
  </mat-dialog-content>
</div>
